import { toast } from 'react-hot-toast'

export function successMessage(message: string) {
  toast.success(message)
}

export function errorMessage(message: string) {
  toast.error(message)
}
